import { useLocation, Redirect } from 'react-router-dom';
import { isUserLogged } from '../utils/utilFunctions';
import { setRedirectPath } from '../utils/redirectAfterLogin';

const PUBLIC_PATHS = ['/', '/autentificare', '/info'];

function isPublicPath(pathname: string): boolean {
  if (pathname === '/') return true;
  return PUBLIC_PATHS.some((p) => p !== '/' && pathname.startsWith(p));
}

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const search = location.search ?? '';
  const fullPath = pathname + search;

  if (isPublicPath(pathname)) {
    return <>{children}</>;
  }

  if (!isUserLogged()) {
    setRedirectPath(fullPath);
    return <Redirect to="/autentificare" />;
  }

  return <>{children}</>;
};

export default AuthGuard;
